var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.507 41.507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#702180;}.cls-2{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Keywords"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20.754,
    cy: 20.754,
    r: 20.754
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.521,30.439H19.37A24.258,24.258,0,0,1,16.9,30.37a2.239,2.239,0,0,1-2.3-2.3,23.764,23.764,0,0,1-.071-2.475V15.911A23.694,23.694,0,0,1,14.6,13.44a2.238,2.238,0,0,1,2.3-2.3,23.481,23.481,0,0,1,2.474-.071h4.04a.678.678,0,0,1,.1-.01.7.7,0,0,1,.144.014,3.3,3.3,0,0,1,1.564.247,13.241,13.241,0,0,1,2.895,2.9,3.3,3.3,0,0,1,.246,1.559.678.678,0,0,1,0,.25V25.6a23.733,23.733,0,0,1-.069,2.473,2.241,2.241,0,0,1-2.3,2.3,22.853,22.853,0,0,1-2.37.069Zm-6.47-17.927a.93.93,0,0,0-1.078,1.08c-.058.516-.062,1.284-.062,2.318V25.6c0,1.038,0,1.8.062,2.319a.929.929,0,0,0,1.08,1.078c.516.058,1.283.062,2.317.062h4.2c1.006,0,1.762,0,2.269-.062a.931.931,0,0,0,1.08-1.078c.058-.516.062-1.283.062-2.319V16.6H23.521a.692.692,0,0,1-.692-.692V12.451H19.37c-1.038,0-1.8,0-2.319.063Zm7.162,2.707h2.75a.965.965,0,0,0-.088-.381A14.509,14.509,0,0,0,24.6,12.555a.983.983,0,0,0-.384-.088ZM24.9,26.98H17.967a.692.692,0,0,1,.019-1.384h6.939a.692.692,0,0,1-.01,1.384Zm-6.937-2.767a.692.692,0,0,1,.019-1.384h6.939a.692.692,0,0,1-.021,1.384ZM24.9,21.446H17.967a.692.692,0,0,1,.019-1.384h6.939a.692.692,0,0,1-.01,1.384Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerate);
export default __webpack_public_path__ + "static/media/generate.9993075a05dc6bea462f81aa03efa8a6.svg";
export { ForwardRef as ReactComponent };